import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index/Index'
import Asset from '@/pages/asset/Asset'
import Finance from '@/pages/finance/Finance'
import Digital from '@/pages/digital/Digital'
import Origin from '@/pages/origin/Origin'
import Service from '@/pages/service/Service'
import About from '@/pages/about/About'

Vue.use(Router)

let router = new Router({
  mode: (!!(window.history && history.pushState) ? 'history' : 'hash'),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  // base:'/boluo/',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/asset',
      name: 'Asset',
      component: Asset
    },
    {
      path: '/finance',
      name: 'Finance',
      component: Finance
    },
    {
      path: '/digital',
      name: 'Digital',
      component: Digital
    },
    {
      path: '/origin',
      name: 'Origin',
      component: Origin
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/about',
      name: 'About',
      component: About
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.length ===0) {                                        //如果未匹配到路由
    from.name ? next({ name:from.name }) : next('/');   //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  } else {
    next();                                                                            //如果匹配到正确跳转
  }
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js